<template>
  <div class="header-search">
    <span style="margin-left: 20px">关键词：</span>
    <el-input v-model="request.keywordStr" placeholder="输入关键字搜索…" class="input">
      <template #prefix>
        <i class="el-input__icon el-icon-search"></i>
      </template>
    </el-input>

    <span style="margin-left: 20px">立项时间：</span>
    <el-select v-model="request.submitYear">
      <el-option label="2022" value="2022" />
      <el-option label="2023" value="2023" />
      <el-option label="2024" value="2024" />
    </el-select>
    <el-button type="primary" style="margin-left: 20px" @click="Search">查询</el-button>
  </div>
  <div class="divTable">
    <el-table :data="tableData.Models" height="538">
      <el-table-column prop="SchoolNo" label="学校编码" show-overflow-tooltip />
      <el-table-column prop="SchoolName" label="学校名称" show-overflow-tooltip />
      <el-table-column prop="SubmitYear" label="立项时间" show-overflow-tooltip />
      <el-table-column prop="EduApplyType" label="项目类别" show-overflow-tooltip />
      <el-table-column label="负责人" show-overflow-tooltip>
        <template #default="scope">
          <p v-for="item in scope.row.LeaderNames" :key="item">
            {{ item.Leader }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <span class="cursor green" @click="review(scope.row.Id)">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="demo-pagination-block table-pagination-page">
      <el-pagination
        v-model:currentPage="request.PageIndex"
        :page-sizes="[10, 20, 50, 100]"
        v-model:page-size="request.PageSize"
        background
        layout=" total,sizes, prev, pager, next, jumper"
        :total="tableData.total"
        @size-change="Search"
        @current-change="Search"
      >
      </el-pagination>
    </div>
  </div>

  <el-drawer v-model="drawer" title="作品信息" :with-header="false" size="40%">
    <div class="info">
      <div class="info-box">作品信息</div>
      <div class="bg-gray"></div>
      <div class="info-title">教改中期项目提交信息</div>
      <div class="info-box">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple info-text">
              学校编码：<span class="text">{{ vModel.SchoolNo }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light info-text">
              学校名称：<span class="text">{{ vModel.SchoolName }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple info-text">
              用户姓名：<span class="text">{{ vModel.UserName }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple info-text">
              用户手机号：<span class="text">{{ vModel.Phone }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple info-text">
              用户邮箱：<span class="text">{{ vModel.Email }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="bg-gray"></div>
      <div class="info-box">
        <el-descriptions
          class="margin-top"
          title="负责人及附件"
          :column="2"
          direction="vertical"
          border
        >
          <div v-for="item in vModel.LeaderNames" :key="item">
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">负责人{{ item.Index }}</div>
              </template>
              {{ item.Leader }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template #label>
                <div class="cell-item">负责人{{ item.Index }}附件</div>
              </template>
              <a :href="getURL(item.FilePath)" target="_blank">{{ item.FileName }}</a>
            </el-descriptions-item>
          </div>
        </el-descriptions>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import {
  GetEducationReformSubmitPageList,
  GetEducationReformSubmitSingle,
} from "../../../http/psychologyTemp";
import { getURL } from "../../../utils/utils";
export default {
  mounted() {
    this.Search();
  },
  data() {
    const submitYear = ref(new Date().getFullYear());
    const request = {
      PageIndex: 1,
      PageSize: 10,
      keywordStr: "",
      submitYear: submitYear,
      ForumId: "6",
    };
    const tableData = reactive({
      Models: [],
      total: 0,
    });
    const requestDetail = {
      keyId: "",
    };
    return {
      getURL,
      submitYear,
      request,
      tableData,
      drawer: false,
      requestDetail,
      vModel: {},
    };
  },
  methods: {
    Search() {
      GetEducationReformSubmitPageList(this.request).then((res) => {
        if (res.IsSuccess) {
          this.tableData.Models = res.Models;
          this.tableData.total = res.TotalCount;
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    },
    review(obj) {
      this.drawer = true;
      this.requestDetail.keyId = obj;
      GetEducationReformSubmitSingle(this.requestDetail).then((res) => {
        if (res.IsSuccess) {
          this.vModel = res.Model;
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    },
  },
};
</script>
<style scoped>
.input {
  width: 200px;
  margin-left: 15px;
}

.divTable {
  margin: 30px 10px 0 15px;
}

.cursor {
  cursor: pointer;
  color: #67c23a;
}

.info {
  width: 90%;
  margin: 0 auto;
}

.info-title {
  margin-top: 30px;
}

.info-box {
  margin-top: 20px;
  margin-bottom: 40px;
}

.info-text {
  margin-top: 20px;
  font-size: 13px;

  > a:hover {
    text-decoration: underline #409eff;
  }
}

.text {
  color: rgb(0, 0, 0, 0.8);
  font-size: 13px;
}

.info-btn {
  margin-top: 50px;
}

.bg-gray {
  background-color: #ececec;
  height: 1px;
  width: 100%;
}

.info-annex {
  > a {
    text-decoration: none;
    color: #409eff;
  }
}
</style>
